import { DROPDOWN_CONTENT } from './dropDownConstants';

export const useSmallDropDownMenu = ({
  slug,
  isPageScrolledDown,
  isDropMenuOpened,
  closeDropDownMenu,
  selected,
  theme,
  disableAnimation,
}) => {
  const SubNavigationLinks = slug ? DROPDOWN_CONTENT[slug] : null;

  const handleOnLinkClick = (subMenuLinkSlug) => () => {
    if (subMenuLinkSlug) {
      closeDropDownMenu();
    }
  };

  return {
    slug,
    isPageScrolledDown,
    isDropMenuOpened,
    SubNavigationLinks,
    handleOnLinkClick,
    selected,
    theme,
    disableAnimation,
  };
};
